import React, {Component} from 'react';
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import {checkChargePaymentStatus, processPayment} from "../../../api/payment";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CreditCard from '@material-ui/icons/CreditCard';
import Bank from '@material-ui/icons/AccountBalance';
import PropTypes from 'prop-types';
import {PAYMENT_METHOD_CREDIT_CARD} from "./helpers";

const styles = theme => ({
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  fabProgress: {
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  footer: {
    padding: '1rem',
    overflow: 'hidden',
  },
});

const ProcessingBody = () => <span>
  Your account will be created shortly. <br/>
  Please do not close this window.
</span>;

class ProcessPaymentModal extends Component {
  constructor(props) {
    super(props);
    this.paymentProcessingTimeout = 3 * 60 * 1000; // 3min
    this.state = {
      error: ''
    };
  }

  setFailureState = () => {
    this.setState({error: 'We encountered an error while processing your payment'});
  };

  componentDidMount() {
    let timeUsed = 0;
    const interval = 2000;
    const checkStatus = (task_id) => {
      setTimeout(() => checkChargePaymentStatus(this.props.sessionKey, task_id)
        .then(({data}) => {
          timeUsed += interval;
          if (data.ready && data.error) return this.setState({error: data.message});
          else if (data.ready && data.success) return this.props.onSuccess(data);
          else if (timeUsed < this.paymentProcessingTimeout) checkStatus(task_id);
          else this.setFailureState();
        })
        .catch(this.setFailureState),
        interval);
    };
    processPayment(this.props.sessionKey).then(({data}) => {
      const {task_id, success} = data;
      if (task_id && success) checkStatus(task_id);
    });
  }

  render() {
    const {classes, paymentMethod} = this.props;
    const Icon = paymentMethod === PAYMENT_METHOD_CREDIT_CARD ? CreditCard : Bank;
    return (
      <Dialog
        open
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {this.state.error || 'We are processing your payment'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.state.error ? 'Please call us at 1-844-768-6945 to complete your sign-up.' : <ProcessingBody/>}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.footer}>
          {
            !this.state.error && <div className={classes.wrapper}>
              <Fab color="secondary">
                <Icon/>
              </Fab>
              <CircularProgress size={68} className={classes.fabProgress}/>
            </div>
          }
        </DialogActions>
      </Dialog>
    );
  }
}

ProcessPaymentModal.propTypes = {
  classes: PropTypes.object,
  paymentMethod: PropTypes.string,
  sessionKey: PropTypes.string,
  onSuccess: PropTypes.func
};

export default withStyles(styles)(ProcessPaymentModal);
